import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IWeekendgateways,
  IWeekendgatewaysInitialState,
} from "./weekendgatewaysModel";
import {
  ActiveInactiveWeekendgateways,
  createWeekendgateways,
  deleteWeekendgateways,
  deleteWeekendgatewaysImage,
  getAllActiveWeekendgateways,
  getWeekendgatewaysByID,
  updateWeekendgateways,
  WeekendgatewaysImageUpload,
} from "./services/weekendgateways.services";

const initialState: IWeekendgatewaysInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  WeekendgatewaysID: null,
  WeekendgatewaysList: [],
  WeekendgatewaysDetail: {
    ID: null,
    Name: "",
    DisplayName: "",
    PageURL: "",
    InnerImages: [],
    MainImage: "",
    ShortDescription: "",
    LongDescription: "",
    NoofNights: null,
    Description: "",
    Star: null,
    MetaTitle: "",
    MetaKeywords: "",
    MetaDescription: "",
    DestinationID: null,
    PerCoupleRate: null,
    ExtraAdultRate: null,
    ExtraChildRateWithoutBed: null,
    ExtraChildRateWithBed: null,
    SpecialRate: null,
    Inclusions: "",
    TourInfo: "",
    Activities: "",
    FromDate: "",
    ToDate: "",
    // CWBRate: null,
    // CoupleRate: null,
    // CNBRate: null,
    ActivityID: null,
    IsActive: 1,
  },
};

const weekendgatewaysSlice = createSlice({
  name: "weekendgateways",
  initialState,
  reducers: {
    clearWeekendgatewaysDetails: (state) => {
      state.WeekendgatewaysDetail = initialState.WeekendgatewaysDetail;
    },
    setWeekendgatewaysID: (state, action) => {
      state.WeekendgatewaysID = action.payload;
    },
    clearWeekendgatewaysID: (state) => {
      state.WeekendgatewaysID = initialState.WeekendgatewaysID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createWeekendgateways.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createWeekendgateways.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createWeekendgateways.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateWeekendgateways.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateWeekendgateways.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateWeekendgateways.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteWeekendgateways.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteWeekendgateways.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteWeekendgateways.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getWeekendgatewaysByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getWeekendgatewaysByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.WeekendgatewaysDetail = action.payload;
    });
    builder.addCase(getWeekendgatewaysByID.rejected, (state, action) => {
      state.loading = false;
      state.WeekendgatewaysDetail = initialState.WeekendgatewaysDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveWeekendgateways.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveWeekendgateways.fulfilled,
      (state, action: PayloadAction<IWeekendgateways[]>) => {
        state.loading = false;
        state.WeekendgatewaysList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveWeekendgateways.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WeekendgatewaysList = [];
    });
    builder.addCase(ActiveInactiveWeekendgateways.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveWeekendgateways.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveWeekendgateways.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(WeekendgatewaysImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(WeekendgatewaysImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(WeekendgatewaysImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteWeekendgatewaysImage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteWeekendgatewaysImage.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteWeekendgatewaysImage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearWeekendgatewaysDetails,
  clearWeekendgatewaysID,
  setWeekendgatewaysID,
} = weekendgatewaysSlice.actions;
export default weekendgatewaysSlice.reducer;
